import { makeStyles } from '@material-ui/styles';

import { teal } from 'shared/styles/colors';

export default makeStyles({
  info: {
    fontWeight: 400,
    fontSize: '0.75rem',
    lineHeight: '1.25rem',
  },
  streetContainer: {
    display: 'flex',
    gap: '1rem',
    justifyContent: 'space-between',
  },
  viewMap: {
    fontWeight: 600,
    color: teal[50],
    textWrap: 'nowrap',
    textDecoration: 'none',
  },
});
